import { render, staticRenderFns } from "./ShopsInfo.vue?vue&type=template&id=458db7be&scoped=true"
import script from "./ShopsInfo.vue?vue&type=script&lang=js"
export * from "./ShopsInfo.vue?vue&type=script&lang=js"
import style0 from "./ShopsInfo.vue?vue&type=style&index=0&id=458db7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458db7be",
  null
  
)

export default component.exports